import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";

/*
----------------------------------------------------------------------------
🔥 SCROLL TO TOP — V88
----------------------------------------------------------------------------
🎯 El botón aparece recién cuando el usuario supera la mitad del recorrido
   real de la página. Si la vista no tiene suficiente scroll, permanece oculto.
----------------------------------------------------------------------------
*/
export const ScrollToTopButton = ({ ratio = 0.5 }) => {
    const [useNameIsVisibleState, setNameIsVisibleState] = useState(false);

    useEffect(() => {
        let frame = null;

        const updateVisibility = () => {
            const documentHeight = Math.max(
                document.documentElement.scrollHeight,
                document.body?.scrollHeight || 0,
            );
            const scrollableDistance = Math.max(0, documentHeight - window.innerHeight);
            const safeRatio = Math.min(0.9, Math.max(0.1, Number(ratio) || 0.5));
            const threshold = scrollableDistance * safeRatio;

            setNameIsVisibleState(scrollableDistance > 240 && window.scrollY >= threshold);
        };

        const scheduleUpdate = () => {
            if (frame) cancelAnimationFrame(frame);
            frame = requestAnimationFrame(updateVisibility);
        };

        updateVisibility();
        window.addEventListener("scroll", scheduleUpdate, { passive: true });
        window.addEventListener("resize", scheduleUpdate, { passive: true });

        return () => {
            if (frame) cancelAnimationFrame(frame);
            window.removeEventListener("scroll", scheduleUpdate);
            window.removeEventListener("resize", scheduleUpdate);
        };
    }, [ratio]);

    return (
        <button
            type="button"
            className="LStudio__app_scroll_top"
            data-active={useNameIsVisibleState ? "true" : "false"}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            aria-label="Volver arriba"
            title="Volver arriba"
            aria-hidden={!useNameIsVisibleState}
            tabIndex={useNameIsVisibleState ? 0 : -1}
        >
            <FaArrowUp />
        </button>
    );
};
